import {
  UserBlock,
  Text,
  Heading,
  Link,
  Box,
  IconFa,
} from "@cruk/cruk-react-components";
import { faClock } from "@fortawesome/free-regular-svg-icons";

import { imagePathFromImageType } from "@fwa/src/services/imageService";
import { secondsToDurationString } from "@fwa/src/utils/timeUtils";
import { useBrandContext } from "@fwa/src/contexts/BrandContext";
import { useTimeAgo } from "@fwa/src/hooks/useTimeAgo";

import sharedStyles from "@fwa/src/components/styles.module.css";
import styles from "@fwa/src/components/FeedItemStrava/styles.module.css";

import { type FeedItemActivityStravaType } from "@fwa/src/types";

const stravaLogo = "/assets/images/logos/strava-rounded-128.png";

type Props = {
  feedItem: FeedItemActivityStravaType;
  avatarUrl: string | undefined;
  displayName: string;
  isMetric: boolean;
};

export const FeedItemStrava = ({
  feedItem,
  avatarUrl,
  displayName,
  isMetric,
}: Props) => {
  const [brandName] = useBrandContext();
  const timeAgo = useTimeAgo(feedItem.created);
  return (
    <div data-component="feed-item-strava">
      <Box marginBottom="xs">
        <UserBlock
          name={displayName}
          avatarUrl={avatarUrl}
          extra={
            <Text as="span" textColor="currentColor">
              <IconFa faIcon={faClock} />
              {timeAgo}
            </Text>
          }
          size="m"
          themeName={brandName}
        />
      </Box>
      <Heading h3 textSize="l">
        {feedItem.name}
      </Heading>
      <Box marginBottom="s">
        <div style={{ maxWidth: "400px" }}>
          <div className={sharedStyles["row-stretch"]}>
            <div className={sharedStyles["column"]}>
              <Text marginBottom="xxs">Activity</Text>
              <Text>{feedItem.stravaActivityType}</Text>
            </div>
            <div className={sharedStyles["column"]}>
              <Text marginBottom="xxs">Distance</Text>
              {isMetric ? (
                <Text>{((feedItem.distance || 0) / 1000).toFixed(2)}km</Text>
              ) : (
                <Text>{((feedItem.distance || 0) / 1609.34).toFixed(2)}mi</Text>
              )}
            </div>
            <div className={sharedStyles["column"]}>
              <Text marginBottom="xxs">Time</Text>
              {feedItem.time ? (
                <Text> {secondsToDurationString(feedItem.time)}</Text>
              ) : null}
            </div>
          </div>
        </div>
      </Box>
      {feedItem.map && (
        <Box marginBottom="s">
          <img
            className="feed-item__strava-map"
            src={
              feedItem.map.image
                ? imagePathFromImageType(feedItem.map.image)
                : ""
            }
            alt=""
          />
        </Box>
      )}

      <div className={sharedStyles["row"]}>
        <div className={styles["logo-image-wrapper"]}>
          <img
            src={stravaLogo}
            alt="Strava activity"
            className="profile-image"
          />
        </div>
        <Link
          appearance="secondary"
          href={`https://www.strava.com/activities/${feedItem.stravaId || ""}`}
        >
          View on Strava
        </Link>
      </div>
    </div>
  );
};

export default FeedItemStrava;
